var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusCircleFilled = function SvgMinusCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 8c0 3.315-2.685 6-6 6s-6-2.685-6-6 2.685-6 6-6 6 2.685 6 6m-8.61.58c.044.066.22.094.277.085h4.666c.056.01.233-.019.276-.085a.35.35 0 0 0 .056-.226v-.708a.35.35 0 0 0-.056-.226c-.043-.066-.22-.094-.276-.085H5.667c-.056-.01-.233.019-.276.085a.35.35 0 0 0-.056.226v.708a.35.35 0 0 0 .056.226Z",
    clipRule: "evenodd"
  })));
};
export default SvgMinusCircleFilled;